import { modalRoute } from '@/router/helpers/modalRoute'

export const userRoutes = [
  {
    path: 'users',
    name: 'Users',
    component: () => import('@/components/users/List.vue'),
    children: [
      modalRoute(
        'add',
        'AddNewMember',
        () => import('@/components/users/modals/Add.vue'),
      ),
      modalRoute(
        'view/:userId',
        'ShowMember',
        () => import('@/components/users/modals/View.vue'),
      ),
      modalRoute(
        'view/:userId/edit',
        'EditMember',
        () => import('@/components/users/modals/Edit.vue'),
        {
          alias: 'edit/:userId',
          // meta: {
          //   permissions: ['userEdit'],
          // },
        },
      ),
      modalRoute(
        'view/:userId/wallet-access',
        'WalletAccessEditor',
        () => import('@/components/users/modals/WalletAccess.vue'),
      ),
      modalRoute(
        'view/:userId/duplicate',
        'DuplicateMember',
        () => import('@/components/users/modals/Add.vue'),
        {
          alias: 'duplicate/:userId',
        },
      ),
      modalRoute(
        'view/:userId/delete',
        'DeleteMember',
        () => import('@/components/users/modals/Delete.vue'),
        {
          alias: 'delete/:userId',
          // meta: {
          //   permissions: ['userEdit'],
          // },
        },
      ),
    ],
  },
]
